module.exports = __webpack_public_path__ + "static/media/PofPTermsOfUseSpanish.a09d0d04.pdf";